import { render, staticRenderFns } from "./live-follow.vue?vue&type=template&id=720a1843&scoped=true&"
import script from "./live-follow.vue?vue&type=script&lang=js&"
export * from "./live-follow.vue?vue&type=script&lang=js&"
import style0 from "./live-follow.vue?vue&type=style&index=0&id=720a1843&prod&scoped=true&lang=scss&"
import style1 from "./live-follow.vue?vue&type=style&index=1&id=720a1843&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a1843",
  null
  
)

export default component.exports